var _linearGradient, _linearGradient2, _radialGradient, _radialGradient2, _linearGradient3, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _linearGradient4, _radialGradient7, _radialGradient8, _linearGradient5, _radialGradient9, _radialGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpainDaily6From49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1.085,
    x2: 0.5,
    y2: 0.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#f1b53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#fae850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffa57"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 0.999,
    x2: 0.5,
    y2: -0.001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#f1b53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#f2b940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#f4c644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#f7db4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#f8e04d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffa57"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 15.184,
    cy: 11.787,
    r: 4.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 15.924,
    cy: 19.358,
    r: 4.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffa57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#fae850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#f1b53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 62.686,
    cy: 39.646,
    r: 11.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa9451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#af9951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#bea850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#d6c04f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8e14e"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 77.246,
    cy: 40.359,
    r: 1.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 57.06,
    cy: 37.448,
    r: 5.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 13.234,
    cy: 37.77,
    r: 7.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -0.001,
    y1: 0.491,
    x2: 1,
    y2: 0.491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 84.286,
    cy: 38.328,
    r: 3.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 40.815,
    cy: 32.116,
    r: 8.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 34.492,
    cy: 41.797,
    r: 9.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 7.267,
    cy: 45.314,
    r: 0.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa9451"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.722 59.445c-.45-.808-2.149-1.525-4.124-1.341s-2.783-.184-3.049-.716c-.266-.542 0-.808.716-1.258s.625-1.433.184-1.617c-.45-.184-.808.808-2.425.625s-1.975-2.002-1.975-2.002.983-3.022-1.341-6.788c-2.333-3.747-9.506-11.554-11.389-13.162s-4.298-4.39-7.89-3.499c-3.582.9-9.093 3.224-13.107 5.199s-7.871 4.124-9.571 4.216-4.932-1.166-6.815-1.341-3.316.625-5.107 2.067c-1.791 1.433-3.94 2.333-4.932 2.599-.983.266-3.766.9-5.024 1.341-1.258.45-3.316-.184-3.858-1.433-.542-1.258-.542-2.067 2.425-4.84 2.958-2.783 2.425-1.791 4.298-3.132s1.617-2.149 1.617-2.149-2.067-.092-3.94 1.617c-1.883 1.699-3.141 2.866-4.298 3.674-1.166.808-2.507.983-2.691 3.224s.45 4.39 2.149 4.84 3.766 0 5.649-.45 2.958-.266 2.958-.266.542.266-.358 1.433-1.617 2.866-1.617 2.866-1.617.9-2.333 1.075-3.049-.432-4.216.772-2.691 3.444-3.94 5.952c-1.258 2.507-2.866 2.958-2.958 3.499s-1.791 2.958-1.791 2.958-.092 4.39 0 6.181c.018.358.018.634.028.9h5.575c-.11-.68-.303-1.442-.67-1.975-.808-1.166-2.599-1.791-2.241-3.141.358-1.341 6.898-6.99 7.89-7.623.983-.625 2.057-.266 2.691 0 .625.266 2.241.45 3.499.45s1.791.092 1.791.092-.625 2.691.983 3.94c1.617 1.258 6.181 1.626 9.139 2.471s3.582.67 3.766 1.47c.175.808.092 1.617.45 1.791l.358.175s.45 1.341.45 1.883v.45h4.997c-.046-.661-.175-1.488-.56-1.791-.67-.542-1.387-.9-1.653-2.425s-1.433-2.691-3.141-3.224c-1.699-.542-5.915-1.708-6.54-2.149-.625-.45-.9-.983.092-1.525.983-.542 1.791-1.166 4.657-2.599s3.94-3.049 5.29-3.499c1.341-.45 1.699.45 2.958 1.525s1.708 1.433 2.866 1.699c1.166.266 2.057-.45 2.333.45.266.9-.037 1.075-.643 1.341s-.248 1.258-1.323 2.507c-1.075 1.258-1.699 2.241-1.617 3.141.092.9.625 1.433.9 2.241.266.808-.175 1.617.092 3.224a14.6 14.6 0 0 1 .129 1.075h5.281c-.175-.762-.459-1.745-.836-2.507-.716-1.433-1.258-2.149-1.075-3.141.175-.983 2.333-2.425 3.766-4.032 1.433-1.617 1.617-1.617 3.049-2.067s1.525-.808 2.333-.9 1.791.184 1.791 1.617-1.525 2.122-1.975 3.123-1.433 1.718-2.057 1.093c-.377-.377-1.313-.496-1.993-.533-.918 1.02-1.139 1.984-1.378 3.343-.211 1.157-.147 2.416.092 2.967.45-.257 1.892-.79 2.379-1.121 1.075-.716.716-1.258 1.975-1.525s1.341.542 2.958-1.341 2.783-3.132 3.766-4.124c.964-.964.964-1.589 1.24-2.397.266-.808.625-2.425.625-2.425s1.699-.184 2.333-.45c.625-.266 1.525.184 2.149.45s1.258 1.075 1.433 1.433c.184.358.358 2.958 0 3.858s-.808 1.433-.45 1.883 1.617.092 1.791.716c.184.625.808.9 1.791.9s1.341-.625 1.699-1.166 1.433-.211 2.691-1.534c1.258-1.332 2.241-2.498 2.783-2.673.542-.184.808-.808 1.258-.184s1.166.808 2.866.625c1.699-.175 2.507-.716 3.674-.625 1.166.083 2.691.533 2.25-.276z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.744 68.86s-.22-.983-.964-1.433-1.819-1.975-.652-3.224c1.166-1.258 3.499-3.766 5.024-4.84s3.61-3.003 4.749-2.866 1.681.468 3.628.873 3.095.34 3.564.808 1.01 1.277 1.01 1.681.404 2.214 2.691 2.82 6.586 1.35 8.266 1.754 2.627 1.414 2.59 2.149c-.037.744.294 1.139.772 1.479.468.34.34 1.681.34 1.681h2.958s-.138-.606-.468-.937c-.34-.34-1.414-1.414-1.543-2.489-.138-1.075-.753-2.241-3.022-3.196-2.278-.955-6.457-1.708-7.127-2.517s-.064-1.947 1.745-2.958l6.356-3.628c2.113-1.277 2.783-2.351 4.06-2.351s2.287 1.341 2.893 2.287c.606.937 1.617 1.277 2.82 1.745 1.212.468 2.553.606 2.553 1.745s-.873 1.341-1.212 1.745-1.01 1.617-1.414 2.223-.68 1.819-.946 2.691.138 1.075.478 2.223c.34 1.139.404 1.883.404 2.489s.202.937.202.937h2.82s.064-.873-.542-2.489-1.277-3.16 0-4.298 2.691-2.755 3.701-4.106c1.01-1.341 1.212-.937 2.618-1.277 1.414-.34 1.947-.542 2.691-.808s1.819.542 2.351 1.617c.542 1.075.606 2.149 0 2.82l-2.425 2.489c-.542.606-.873 1.681-1.883.808s-1.681-.34-1.681-.34-.404.266-.606 1.745-.11 1.754 1.212 1.479 1.543-1.277 2.223-1.341c.67-.064 2.269-.67 3.591-2.755s2.259-1.819 3.003-3.297.266-3.362 1.075-3.426 1.543-.606 2.021-1.139c.468-.542.873-.873.873-.873h1.819a4.831 4.831 0 0 0 1.277.873c.744.34 1.414.606 1.617 1.479s1.212.606 1.212.606v1.414s-1.075.34-.937 1.782-.468 1.718-.266 2.186.67-.064 1.212.542 1.139.808 1.681.34.744-1.075 2.021-1.617 2.085-1.01 2.755-2.085l1.341-1.947s1.01-.202 1.883.404 1.543.606 1.745.404-.606-.404-.808-.937a2.84 2.84 0 0 0-1.479-1.681c-.937-.468-1.341-.808-1.341-.808s0-.468-.542-.937-.873-1.01-.744-1.212c.138-.202.744-2.021-.937-5.245s-5.584-7.127-9.341-11.499c-3.766-4.372-5.511-6.457-7.936-6.181-2.425.266-10.82 4.234-15.265 6.457-4.436 2.223-8.064 2.82-10.351 2.958s-4.703-1.819-6.586-.67c-1.883 1.139-4.501 2.958-5.777 3.628s-1.883.744-1.883 1.479c0 .744-.138 2.287-1.479 3.766s-2.021 2.7-3.297 2.967-3.766-1.084-5.245 1.001-2.691 4.703-3.628 6.117-2.223 2.82-3.095 3.904c-.873 1.075-1.543 1.745-1.543 2.425 0 .67.266 5.309.266 5.309h2.958c-.018-.046.147-.276-.101-.918z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.978 69.732.018.744h5.575c-.037-.239-.11-.496-.175-.744H6.978zm42.434 0 .083.744h5.281l-.202-.744h-5.162zm-8.762 0a1.84 1.84 0 0 1 .028.294v.45h4.997a7.21 7.21 0 0 0-.101-.744h-4.923z",
    fill: "#867c5e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 37.484c2.958-2.783 2.425-1.791 4.298-3.132a7.385 7.385 0 0 0 .698-.56c-2.406.928-4.693 2.333-5.832 3.343s-2.82 2.287-2.82 3.297c0 .579.413 1.111 1.084 1.506-.349-1.065-.064-1.975 2.572-4.455z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.145 44.924c.138-.744.018-1.525-1.947-.67-1.975.854-5.511.606-7.596.542-.487-.018-.863.018-1.185.028.312.349.689.615 1.166.735 1.699.45 3.766 0 5.649-.45s2.958-.266 2.958-.266.349.193-.018.9c.514-.266.928-.551.974-.817z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.199 55.349c-.34.11-.487.413-.569.744l.156-.055c.625-.266 1.525.184 2.149.45s1.258 1.075 1.433 1.433c.037.073.073.248.101.459.202-.726.266-1.369.028-1.69-.404-.533-2.287-1.681-3.297-1.341z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.847 66.802c1.258-.266 1.341.542 2.958-1.341l3.766-4.124c.983-.992.983-1.617 1.258-2.425.129-.386.276-.964.404-1.46-.331.046-.588.202-.661.588-.202 1.075-1.212 2.305-2.085 3.83s-3.417 3.463-4.106 4.17c-.68.707-1.001.569-1.341.34-.349-.239-1.543 1.01-2.021 1.341-.468.34-1.947.808-2.149.67-.138-.092-.367-1.46-.303-2.765l-.165.854c-.211 1.157-.147 2.416.092 2.967.45-.257 1.892-.79 2.379-1.121 1.084-.726.716-1.258 1.975-1.525z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.826 63.128c-.037.193-.037.377.092.542.358.45 1.617.092 1.791.716.092.331.321.551.643.698.119-.303.165-.634-.184-1.056-.808-1.001-1.58-.514-2.342-.9z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.848 57.296c-1.479.34-1.947 1.139-2.958 1.212-1.01.064-1.571.202-2.333 1.681-.772 1.479-3.573 2.985-3.986 4.106-.211.569.009.992.312 1.304a2.122 2.122 0 0 1-.009-.762c.175-.983 2.333-2.425 3.766-4.032 1.433-1.617 1.617-1.617 3.049-2.067s1.525-.808 2.333-.9c.22-.028.45-.009.67.028-.046-.423-.276-.698-.845-.569z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.136 65.498c.064.597.367.817.726.937-.202-.312-.312-.652-.202-1.065.358-1.341 6.898-6.99 7.89-7.623.983-.625 2.057-.266 2.691 0 .625.266 2.241.45 3.499.45s1.791.092 1.791.092-2.544-.716-4.152-.716-3.04-1.901-5.979 1.341c-2.958 3.242-6.42 5.07-6.264 6.586z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.48 59.721c1.01.073 2.287.423 2.315-.009-1.369-.496-2.608-.836-3.352-.79-1.258.073-2.324.79-3.16 1.47l.524-.028c1.699-.202 2.507-.735 3.674-.643z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9 62.568c1.258-1.332 2.241-2.498 2.783-2.673.257-.083.45-.266.634-.377-.239-.248-.542-.358-.955-.165-1.451.698-1.121 2.599-3.499 3.316-2.37.716-2.03.983-2.691 1.791-.156.184-.239.459-.294.744.698-.138 1.029-.643 1.341-1.102.349-.533 1.424-.202 2.682-1.534z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.147 56.084c-1.029.257-2.618-1.414-3.499-2.287-.873-.873-2.452-1.874-3.49-.67s-5.456 3.095-6.797 4.032-3.435 2.085-3.628 2.755c-.064.239.202.423.634.569-.257-.349-.211-.744.496-1.13.983-.542 1.791-1.166 4.657-2.599s3.94-3.049 5.29-3.499c1.341-.45 1.699.45 2.958 1.525s1.708 1.433 2.866 1.699c1.166.266 2.057-.45 2.333.45.266.9-.037 1.075-.643 1.341a.505.505 0 0 0-.22.193c.744-.321 1.323-.606 1.47-.909.294-.615-1.387-1.727-2.425-1.47z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.502 57.232c-.138-.432.119-.698.762-1.102.588-.367.615-1.075.367-1.424a3.25 3.25 0 0 1-.331.533c-1.148 1.414-1.369 1.892-.799 1.993z",
    fill: "url(#m)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.485 60.309c.11.698.395 1.424 1.038 1.92 1.617 1.258 6.181 1.626 9.139 2.471s3.582.67 3.766 1.47c.175.808.092 1.617.45 1.791l.358.175.239.781c.202-.248.312-.459.184-.67-.45-.744-.79-1.075-.716-1.681.064-.606.266-1.414-4.17-2.287s-7.587-1.047-8.937-2.553l-1.35-1.414z",
    fill: "url(#n)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.396 67.923c.037.542.165 1.056.918 1.451a3.49 3.49 0 0 0-.404-.873c-.147-.211-.331-.395-.514-.579z",
    fill: "url(#o)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpainDaily6From49);
export default __webpack_public_path__ + "static/media/spain_daily_6_from_49.7a106b45fd296c875e0396b6f1242bdb.svg";
export { ForwardRef as ReactComponent };